<div *ngIf="isLoading">Loading StatusCategory List...</div>

<select *ngIf="!isLoading" [compareWith]="byId" class="form-control" name="statusCategory"
        [(ngModel)]="model.statusCategory" [required]="required">
  <option *ngFor="let singleStatusCategory of statusCategories" [ngValue]="singleStatusCategory">{{
    singleStatusCategory.name }}
  </option>
</select>
